import { render, staticRenderFns } from "./live_science_upload.vue?vue&type=template&id=8d9041c0&"
import script from "./live_science_upload.vue?vue&type=script&lang=js&"
export * from "./live_science_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports